module.exports = __webpack_public_path__ + "media/images/talent/lp/feature04-d3447d7096c835f3eb5080e037d57e26.png";